module.exports = __webpack_public_path__ + "img/en.d980eb2c.png";